function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Vex } from './vex';
import { BravuraFont } from './fonts/bravura_glyphs';
import { BravuraMetrics } from './fonts/bravura_metrics';
import { GonvilleFont } from './fonts/gonville_glyphs';
import { GonvilleMetrics } from './fonts/gonville_metrics';
import { PetalumaFont } from './fonts/petaluma_glyphs';
import { PetalumaMetrics } from './fonts/petaluma_metrics';
import { CustomFont } from './fonts/custom_glyphs';
import { CustomMetrics } from './fonts/custom_metrics';

var Font = /*#__PURE__*/function () {
  function Font(name, metrics, fontData) {
    _classCallCheck(this, Font);

    this.name = name;
    this.metrics = metrics;
    this.fontData = fontData;
    this.codePoints = {};
  }

  _createClass(Font, [{
    key: "getName",
    value: function getName() {
      return this.name;
    }
  }, {
    key: "getResolution",
    value: function getResolution() {
      return this.fontData.resolution;
    }
  }, {
    key: "getMetrics",
    value: function getMetrics() {
      return this.metrics;
    }
  }, {
    key: "lookupMetric",
    value: function lookupMetric(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var parts = key.split('.');
      var val = this.metrics; // console.log('lookupMetric:', key);

      for (var i = 0; i < parts.length; i++) {
        if (val[parts[i]] === undefined) {
          if (defaultValue !== undefined) {
            return defaultValue;
          } else {
            throw new Vex.RERR('INVALID_KEY', "Invalid music font metric key: ".concat(key));
          }
        }

        val = val[parts[i]];
      } // console.log('found:', key, val);


      return val;
    }
  }, {
    key: "getFontData",
    value: function getFontData() {
      return this.fontData;
    }
  }, {
    key: "getGlyphs",
    value: function getGlyphs() {
      return this.fontData.glyphs;
    }
  }, {
    key: "getCodePoints",
    value: function getCodePoints() {
      return this.codePoints;
    }
  }, {
    key: "setCodePoints",
    value: function setCodePoints(codePoints) {
      this.codePoints = codePoints;
      return this;
    }
  }]);

  return Font;
}();

var Fonts = {
  Bravura: new Font('Bravura', BravuraMetrics, BravuraFont),
  Gonville: new Font('Gonville', GonvilleMetrics, GonvilleFont),
  Petaluma: new Font('Petaluma', PetalumaMetrics, PetalumaFont),
  Custom: new Font('Custom', CustomMetrics, CustomFont)
};
var DefaultFontStack = [Fonts.Bravura, Fonts.Gonville, Fonts.Custom];
export { Fonts, DefaultFontStack, Font };